export enum BrandID {
  IEC = "IEC", CLM = "CLM", CCG = "CCG", CLC = "CLC"
}
